import { render, staticRenderFns } from "./WeekPeriodRule.vue?vue&type=template&id=8ed5bb40&scoped=true"
import script from "./WeekPeriodRule.vue?vue&type=script&lang=js"
export * from "./WeekPeriodRule.vue?vue&type=script&lang=js"
import style0 from "./WeekPeriodRule.vue?vue&type=style&index=0&id=8ed5bb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed5bb40",
  null
  
)

export default component.exports